import apiClient from '@/services/http';

export default {
    getUserProfile() {
        return apiClient.get('/user/profile');
    },
    // updateUserProfile(data) {
    //     return apiClient.put('/user/profile', data);
    // }
};
